module.exports = __webpack_public_path__ + "static/img/static_bg1.1627fbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/static_bg1.png
// module id = 8X2P
// module chunks = 37